// Calendar date (YYYY-MM-DD) in the device's local timezone; toISOString() alone would give the UTC day.
export const localISODate = (d = new Date()) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);

export const LONG_DATE = { weekday: "long", day: "numeric", month: "long", year: "numeric" };

// "2026-10-29" → "29 Okt 2026" (id) / "Oct 29, 2026" (en); plain YYYY-MM-DD is parsed as a local day.
export const formatDate = (value, lang, opts = { day: "numeric", month: "short", year: "numeric" }) => {
  if (!value) return "";
  const d = typeof value === "string" && value.length === 10 ? new Date(`${value}T00:00:00`) : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString(lang === "id" ? "id-ID" : "en-US", opts);
};
